import React, { type ReactNode } from "react";
import { Text, Flex, Box, type IconProps } from "@chakra-ui/react";

export function IconTag({ icon, children }: { icon: (props: IconProps) => JSX.Element; children: ReactNode }) {
  return (
    <Flex align="center" bg="new.gray.150" borderRadius="36px" gap="tinier" pr="smallest">
      <Box as={icon} boxSize={{ base: "20px", lg: "24px" }} />
      <Text as="span" textStyle="caption2" fontSize={{ base: "brand.2xs", lg: "brand.xs" }}>
        {children}
      </Text>
    </Flex>
  );
}
